/**
 * @Author: AI Assistant
 * @Date: 2025-07-02 15:42:00
 * @Description: 数据字典路由配置
 */

const MenuLayout = () => import('@/components/layout/index.vue')
const Layout = () => import('@/views/index/index.vue')
const AppList = () => import('@/views/admin/app-list/index.vue')
const AppCategory = () => import('@/views/admin/category/index.vue')
const AppDomain = () => import('@/views/admin/domain/index.vue')
const RoleManage = () => import('@/views/role-manage/index.vue')
export default // 应用管理
{
  path: '/admin',
  // component: layout,
  // component: import('@/views/index/index.vue'),
  component: Layout,
  // 重定向
  redirect: '/admin/app/list',
  children: [
    // 应用管理
    {
      path: 'app',
      name: 'Admin',
      // component: import('@/components/layout/index.vue'),
      component: MenuLayout,
      children: [
        {
          path: 'list',
          name: 'AppList',
          // component: () => import('@/views/admin/app-list/index.vue')
          // component: import('@/views/admin/app-list/index.vue')
          component: AppList,
          meta: {
            name: 'PBC管控',
            context: 'admin',
            type: 'INNER_APP'
          }
        },
        {
          path: 'category',
          name: 'AppCategory',
          // component: () => import('@/views/admin/category/index.vue')
          // component: import('@/views/admin/category/index.vue')
          component: AppCategory,
          meta: {
            name: 'PBC管控',
            context: 'admin',
            type: 'INNER_APP'
          }
        },
        {
          path: 'domain',
          name: 'AppDomain',
          component: AppDomain,
          meta: {
            name: 'PBC管控',
            context: 'admin',
            type: 'INNER_APP'
          }
        },
        {
          path: 'permission',
          name: 'Permission',
          component: RoleManage,
          meta: {
            name: 'PBC管控',
            context: 'admin',
            type: 'INNER_APP'
          }
        }
      ]
    }
  ]
}
